import { render, staticRenderFns } from "./ListAvaliations.vue?vue&type=template&id=d3cc9268"
import script from "./ListAvaliations.vue?vue&type=script&lang=js"
export * from "./ListAvaliations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports